import { IDirectionsInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const directionsSelector = (state: RootState) => state.directions;

const directionsListSelector = createSelector([directionsSelector], (directions: IDirectionsInitialState) => directions.directionsList);

const directionSelector = createSelector([directionsSelector], (directions: IDirectionsInitialState) => directions.direction);

export const directionsSel = {
    directionsSelector,
    directionSelector,
    directionsListSelector,
};
